import moment from 'moment';

export default function syncDateWithOriginalTime(dateWithTime, newDate) {
	return moment(dateWithTime)
		.set({
			year: moment(newDate).get('year'),
			month: moment(newDate).get('month'),
			date: moment(newDate).get('date'),
		})
		.toDate();
}



// WEBPACK FOOTER //
// ./src/core/utils/syncDateWithOriginalTime.js